(function () {
  function keepDropdownOpen(wrapper) {
    if (!wrapper) return;

    wrapper.hidden = false;
    wrapper.removeAttribute('hidden');

    var disclosure = wrapper.closest('.disclosure');
    if (!disclosure) return;

    var trigger = disclosure.querySelector('.disclosure__button');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    var details = wrapper.closest('details');
    if (details) {
      details.setAttribute('open', 'open');
    }
  }

  function createCountryItem(country, currentIso) {
    var li = document.createElement('li');
    li.className = 'disclosure__item';
    li.setAttribute('tabindex', '-1');

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'link link--text caption-large focus-inset xwx-country-option';
    button.dataset.value = country.iso;

    if (country.iso === currentIso) {
      button.setAttribute('aria-current', 'true');
    }

    var check = document.createElement('span');
    check.className = 'xwx-country-check';
    check.setAttribute('aria-hidden', 'true');

    var name = document.createElement('span');
    name.className = 'country';
    name.textContent = country.name;

    var currency = document.createElement('span');
    currency.className = 'localization-form__currency motion-reduce';
    currency.textContent = country.symbol && country.symbol !== country.currency
      ? country.currency + ' ' + country.symbol
      : country.currency;

    button.appendChild(check);
    button.appendChild(name);
    button.appendChild(currency);
    li.appendChild(button);

    return li;
  }

  function loadAllCountries(button) {
    var wrapper = button.closest('.country-selector');
    if (!wrapper) return;

    var list = wrapper.querySelector('[data-xwx-country-list]');
    var jsonScript = wrapper.querySelector('[data-xwx-all-countries-json]');

    if (!list || !jsonScript) return;

    keepDropdownOpen(wrapper);

    if (list.dataset.loaded === 'true') {
      button.hidden = true;
       button.setAttribute('hidden', 'hidden');
      button.style.display = 'none';
      return;
    }

    var countries;

    try {
      countries = JSON.parse(jsonScript.textContent);
    } catch (error) {
      console.error('XWALLX country JSON parse failed', error);
      return;
    }

    var form = button.closest('form');
    var currentInput = form ? form.querySelector('input[name="country_code"]') : null;
    var currentIso = currentInput ? currentInput.value : '';

    var fragment = document.createDocumentFragment();

    countries.forEach(function (country) {
      fragment.appendChild(createCountryItem(country, currentIso));
    });

    list.replaceChildren(fragment);
    list.dataset.loaded = 'true';
    button.hidden = true;
     button.setAttribute('hidden', 'hidden');
     button.style.display = 'none';

    keepDropdownOpen(wrapper);

    var results = wrapper.querySelector('[data-xwx-country-results]');
    if (results) {
      results.textContent = countries.length + ' countries/regions found';
    }
  }

  document.addEventListener('click', function (event) {
    var allCountriesButton = event.target.closest('[data-xwx-load-all-countries]');

    if (allCountriesButton) {
      event.preventDefault();
      event.stopPropagation();
      loadAllCountries(allCountriesButton);
      return;
    }

    var countryButton = event.target.closest('.xwx-country-option');
    if (!countryButton) return;

    event.preventDefault();

    var form = countryButton.closest('form');
    if (!form) return;

    var input = form.querySelector('input[name="country_code"]');
    if (!input) return;

    input.value = countryButton.dataset.value;
    form.submit();
  });
})();